import { useEffect, useRef } from 'react';

import { LiveStreamProps } from '@/types';

const VIDEO_PLAYER_CONSTANT = 'svp_player9r1tycoqh8o4';
interface SVPDynamicPlayerConstructor {
  new (
    id: string,
    secondArg: string,
    width: string,
    height: string,
    options: { use_div: string; skin: string },
    vars: Record<string, string | number | boolean>
  ): SVPDynamicPlayerInstance;
}

interface SVPDynamicPlayerInstance {
  execute: () => void;
  play?: () => void;
  unMute?: () => void;
  mute?: () => void;
  setVolume?: (volume: number) => void;
  addPlayerEventListener?: (event: string, handler: () => void) => void;
}

declare global {
  interface Window {
    SVPDynamicPlayer: SVPDynamicPlayerConstructor;
  }
}

export const LiveStream = ({ streamId }: LiveStreamProps) => {
  const playerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (playerRef.current) {
      const script = document.createElement('script');
      script.src = '//play.webvideocore.net/js/dplayer.js';
      script.async = true;
      script.onload = () => {
        const vars = {
          clip_id: streamId,
          transparent: 'true',
          pause: '0',
          repeat: '',
          bg_color: '#ffffff',
          fs_mode: '2',
          no_controls: '',
          start_img: '0',
          start_volume: '100',
          close_button: '',
          brand_new_window: '1',
          auto_hide: '1',
          stretch_video: '',
          player_align: 'NONE',
          offset_x: '0',
          offset_y: '0',
          player_color_ratio: 0.6,
          skinAlpha: '50',
          colorBase: '#000000',
          colorIcon: '#ffffff',
          colorHighlight: '#5cbbf5',
          direct: 'false',
          is_responsive: 'true',
          viewers_limit: 0,
          cc_position: 'bottom',
          cc_positionOffset: 70,
          cc_multiplier: 0.03,
          cc_textColor: '#ffffff',
          cc_textOutlineColor: '#ffffff',
          cc_bkgColor: '#000000',
          cc_bkgAlpha: 0.1,
          aspect_ratio: '16:9',
          play_button: '1',
          play_button_style: 'pulsing',
          sleek_player: '0',
          auto_play: '1',
          auto_play_type: 'unMute',
          floating_player: 'none'
        };
        const SVPDynamicPlayer = window.SVPDynamicPlayer;
        const svp_player = new SVPDynamicPlayer(
          VIDEO_PLAYER_CONSTANT,
          '',
          '100%',
          '100%',
          { use_div: VIDEO_PLAYER_CONSTANT, skin: '3' },
          vars
        );
        svp_player.execute();
      };
      document.body.appendChild(script);
    }
  }, [streamId]);

  return (
    <div id={VIDEO_PLAYER_CONSTANT} ref={playerRef} className='relative mb-10 h-[400px] w-full' />
  );
};
